'use client'

import { useEffect } from 'react'

import { isProduction, isTest } from '@common/core/helpers'

/**
 * Used for debugging environment configuration.
 * Logs only on dev/localhost – not on test nor prod.
 */
export function EnvLogger() {
  useEffect(() => {
    if (isTest() || isProduction()) {
      return
    }

    console.warn('[Env] NEXT_PUBLIC_APP_ENV:', process.env.NEXT_PUBLIC_APP_ENV ?? '(unset)')
    console.warn('[Env] NEXT_PUBLIC_ANALYTICS_GTM_ID:', process.env.NEXT_PUBLIC_ANALYTICS_GTM_ID ?? '(unset)')
    console.warn('[Env] NEXT_PUBLIC_ANALYTICS_GTM_AUTH:', process.env.NEXT_PUBLIC_ANALYTICS_GTM_AUTH ?? '(unset)')
    console.warn('[Env] NEXT_PUBLIC_ANALYTICS_GTM_PREVIEW:', process.env.NEXT_PUBLIC_ANALYTICS_GTM_PREVIEW ?? '(unset)')
  }, [])

  return null
}
